export default "__VITE_ASSET__557db3aa__"